import React from "react";

import { PageLayout } from "../components/PageLayout";

export default function PrivacyPage() {
  return (
    <PageLayout title="Privacy Policy">
      <div className="container max-w-3xl py-12 space-y-8">
        <h1 className="text-3xl font-bold">Privacy Policy</h1>
        <section className="space-y-4 text-muted-foreground">
          <p>
            This Privacy Policy explains how we collect, use, and protect your
            information when you use SnapNote ("the Service").
          </p>
          <h2 className="text-xl font-semibold text-foreground">
            Information We Collect
          </h2>
          <p>
            We collect only the information necessary to provide and improve the
            Service. This may include usage data and content you submit.
          </p>
          <h2 className="text-xl font-semibold text-foreground">
            Use of Information
          </h2>
          <p>
            We use the collected information to operate and enhance the Service
            and to communicate with you.
          </p>
          <h2 className="text-xl font-semibold text-foreground">
            Data Security
          </h2>
          <p>
            We implement reasonable measures to protect your information.
            However, no method of transmission over the Internet is completely
            secure.
          </p>
          <h2 className="text-xl font-semibold text-foreground">
            Changes to Policy
          </h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify
            you of any changes by posting the new policy on this page.
          </p>
        </section>
      </div>
    </PageLayout>
  );
}
